import type { PlatformDiagnostic, PlatformLanguage } from "./platform-diagnostics";

export function PlatformDiagnosticAlert({
  diagnostic,
  language,
  className = ""
}: {
  diagnostic: PlatformDiagnostic;
  language: PlatformLanguage;
  className?: string;
}) {
  const ar = language === "ar";
  return (
    <div className={`platform-diagnostic ${className}`.trim()} role="alert">
      <strong>{diagnostic.message}</strong>
      {diagnostic.code || diagnostic.correlationId ? (
        <dl>
          {diagnostic.code ? (
            <div>
              <dt>{ar ? "رمز الخطأ" : "Error code"}</dt>
              <dd><bdi dir="ltr">{diagnostic.code}</bdi></dd>
            </div>
          ) : null}
          {diagnostic.correlationId ? (
            <div>
              <dt>{ar ? "معرّف الارتباط" : "Correlation ID"}</dt>
              <dd><bdi dir="ltr">{diagnostic.correlationId}</bdi></dd>
            </div>
          ) : null}
        </dl>
      ) : null}
    </div>
  );
}
